import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import api, { timeAgo } from "@/lib/api";
import { useArticlePath } from "@/lib/i18n";

/* Breaking headline strip (§6). Market data lives in the global NewsLayer
   Pulse ticker directly above — no duplicated prices here. */
export const PulseStrip = () => {
  const toArticle = useArticlePath();
  const { data: breaking } = useQuery({
    queryKey: ["pulse-breaking"],
    queryFn: async () => (await api.get("/breaking")).data,
    staleTime: 60 * 1000,
    retry: 1,
  });
  const a = breaking?.article;
  if (!a) return null;

  return (
    <div className="border-b border-white/[0.07] bg-black/45" data-testid="article-pulse-strip">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 h-9 flex items-center gap-3 overflow-hidden">
        <div className="flex items-center gap-2.5 min-w-0 flex-1">
          <span className={`shrink-0 font-mono text-[8.5px] font-bold uppercase tracking-[0.18em] rounded px-1.5 py-[2px] ${
            a.is_breaking
              ? "text-white bg-[#B91C1C]/85 border border-[#EF4444]/40"
              : "text-[#A78BFA] border border-[#7C3AED]/40"}`}>
            {a.is_breaking ? "Breaking" : "Latest"}
          </span>
          <Link to={toArticle(a.slug)} data-testid="pulse-strip-headline"
            className="min-w-0 truncate text-[12px] font-semibold text-gray-200 hover:text-white transition-colors">
            {a.title}
          </Link>
          {a.published_at && (
            <span className="shrink-0 font-mono text-[10px] text-gray-600 hidden sm:inline">{timeAgo(a.published_at)}</span>
          )}
        </div>
        <Link to="/markets" data-testid="pulse-strip-view-all"
          className="hidden md:flex items-center gap-1 shrink-0 font-mono text-[10px] font-bold uppercase tracking-wider text-gray-500 hover:text-[#00E5FF] transition-colors">
          Markets <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
    </div>
  );
};
